import type {
  LibraryCandidate,
  LibraryFilters,
  LibraryRole,
  LibrarySort,
  LibraryStage,
  LibrarySource,
  LibraryState,
} from './types';

export const LIBRARY_STAGE_KEYS: LibraryStage[] = [
  'inbox',
  'screening',
  'interview',
  'offer',
  'talent_pool',
];

export const LIBRARY_SOURCE_KEYS: LibrarySource[] = ['page', 'email', 'upload', 'scan'];

export const LIBRARY_SORT_KEYS: LibrarySort[] = ['newest', 'match_desc', 'name_asc'];

export const INITIAL_LIBRARY_FILTERS: LibraryFilters = {
  locations: [],
  stages: [],
  sources: [],
  decisions: [],
  collectionIds: [],
  candidateKinds: [],
  starredOnly: false,
};

const INITIAL_ROLES: LibraryRole[] = [
  {
    id: 'role_frontend_senior',
    name: 'Senior Frontend Developer',
    status: 'active',
    createdAt: '2026-03-22T09:00:00.000Z',
  },
  {
    id: 'role_product_designer',
    name: 'Product Designer',
    status: 'active',
    createdAt: '2026-03-28T11:10:00.000Z',
  },
];

const NEUTRAL_AVATAR = {
  cool: '#D8DADF',
  warm: '#DCD8D2',
  slate: '#D1D5DB',
  ash: '#D8D8DE',
} as const;

const INITIAL_CANDIDATES: LibraryCandidate[] = [
  {
    id: 'cand_mohammed_zaabi',
    roleId: 'role_frontend_senior',
    roleIds: ['role_frontend_senior'],
    name: 'Mohammed Al Zaabi',
    title: 'Senior Frontend Developer',
    location: 'Dubai, UAE',
    initials: 'MZ',
    avatarTone: NEUTRAL_AVATAR.cool,
    matchScore: 94,
    stage: 'screening',
    source: 'page',
    decision: 'none',
    starred: false,
    skills: ['React', 'TypeScript'],
    appliedLabel: '2 days ago',
    createdAt: '2026-04-01T08:45:00.000Z',
    kind: 'applicant',
    parseStatus: 'ready',
    collectionIds: [],
    cvSnippet: {
      headline: 'Senior Frontend Developer',
      recentRole: 'Frontend Lead',
      recentCompany: 'Nexa Labs',
      recentPeriod: '2021 - Present',
    },
  },
  {
    id: 'cand_fatima_hashimi',
    roleId: 'role_frontend_senior',
    roleIds: ['role_frontend_senior'],
    name: 'Fatima Al Hashimi',
    title: 'Senior Frontend Developer',
    location: 'Abu Dhabi, UAE',
    initials: 'FH',
    avatarTone: NEUTRAL_AVATAR.slate,
    matchScore: 88,
    stage: 'interview',
    source: 'email',
    decision: 'none',
    starred: true,
    skills: ['Vue.js', 'React', 'UI/UX'],
    appliedLabel: '3 days ago',
    createdAt: '2026-03-31T14:20:00.000Z',
    kind: 'applicant',
    parseStatus: 'ready',
    collectionIds: [],
    cvSnippet: {
      headline: 'Senior Frontend Developer',
      recentRole: 'UX/UI Designer',
      recentCompany: 'DesignHub',
      recentPeriod: '2020 - Present',
    },
  },
  {
    id: 'cand_omar_khalid',
    roleId: 'role_product_designer',
    roleIds: ['role_product_designer'],
    name: 'Omar Khalid',
    title: 'Product Designer',
    location: 'Dubai, UAE',
    initials: 'OK',
    avatarTone: NEUTRAL_AVATAR.warm,
    matchScore: 91,
    stage: 'offer',
    source: 'upload',
    decision: 'none',
    starred: false,
    skills: ['Figma', 'iOS'],
    appliedLabel: '6 days ago',
    createdAt: '2026-03-27T16:05:00.000Z',
    kind: 'external',
    parseStatus: 'ready',
    collectionIds: [],
    cvSnippet: {
      headline: 'Product Designer',
      recentRole: 'Senior Product Designer',
      recentCompany: 'Orbit Studio',
      recentPeriod: '2019 - Present',
    },
  },
  {
    id: 'cand_sara_ahmed',
    roleId: null,
    roleIds: [],
    name: 'Sara Ahmed',
    title: 'Senior Backend Developer',
    location: 'Sharjah, UAE',
    initials: 'SA',
    avatarTone: NEUTRAL_AVATAR.ash,
    matchScore: 85,
    stage: 'inbox',
    source: 'scan',
    decision: 'none',
    starred: false,
    skills: ['Node.js', 'AWS'],
    appliedLabel: '1 week ago',
    createdAt: '2026-03-24T12:30:00.000Z',
    kind: 'external',
    parseStatus: 'ready',
    collectionIds: [],
    cvSnippet: {
      headline: 'Senior Backend Developer',
      recentRole: 'Backend Engineer',
      recentCompany: 'ByteCore',
      recentPeriod: '2018 - Present',
    },
  },
];

export function createInitialLibraryState(): LibraryState {
  return {
    roles: INITIAL_ROLES,
    candidates: INITIAL_CANDIDATES,
    collections: [],
    searchQuery: '',
    sort: 'newest',
    filters: INITIAL_LIBRARY_FILTERS,
    buckets: {
      offlineCvs: 1,
    },
  };
}
